module.exports = __webpack_public_path__ + "static/media/facebook_icon.0b924329.svg";